import { render, staticRenderFns } from "./BaseAppList.vue?vue&type=template&id=42afc2e8&"
import script from "./BaseAppList.vue?vue&type=script&lang=js&"
export * from "./BaseAppList.vue?vue&type=script&lang=js&"
import style0 from "./BaseAppList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports